import { render, staticRenderFns } from "./ModalPesquisar.vue?vue&type=template&id=185cea3f"
import script from "./ModalPesquisar.vue?vue&type=script&lang=js"
export * from "./ModalPesquisar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports